import { useMemo } from 'react'
import { useAuth } from '@/shared/auth/useAuth'
import {
  ACCOUNT_NAV_ITEMS,
  NAV_ITEMS,
  SECONDARY_NAV_ITEMS,
  VOUCHER_FALLBACK_ITEM,
  type NavItem,
} from './navItems'

export interface VisibleNav {
  /** Asosiy to'rtlik — pastki tab-bar VA yuqori menyu */
  primary: readonly NavItem[]
  /** Jurnallar — kompyuterda yuqori menyuda, telefonda hisob menyusida */
  secondary: readonly NavItem[]
  /** Hisob menyusi — HAR DOIM profil dropdownida, qurilmadan qat'i nazar */
  account: readonly NavItem[]
}

/**
 * Huquq bo'yicha filtrlangan navigatsiya — ADR-030 §2 talabi.
 *
 * ⚠️ FILTR BIR JOYDA. Ro'yxatni UCH chiziladigan joy ishlatadi:
 * desktopdagi gorizontal menyu (`AppHeader`), telefondagi pastki
 * tab-bar (`MobileTabBar`) va hisob menyusi (`ProfileMenu`). Filtr har
 * birida qayta yozilsa, ular asta-sekin ayrilib ketardi — admin
 * panelida aynan shu sabab bilan `useSidebarMenu` yozilgan
 * (`admin/src/app/layout/useSidebarMenu.ts` javadoc'i).
 *
 * ⚠️ RO'YXATLAR AJRATILGAN HOLDA QAYTADI, qo'shilib emas: chaqiruvchi
 * ularni BOSHQA joyga chizadi va qo'shib yuborish pastki tab-barni
 * oltita bandga cho'zardi (`navItems.tsx` dagi sabab).
 */
export function useVisibleNav(): VisibleNav {
  const { can } = useAuth()

  return useMemo(() => {
    const allowed = (item: NavItem) => !item.permission || item.permission.some(can)
    const primary = NAV_ITEMS.filter(allowed)
    const secondary = SECONDARY_NAV_ITEMS.filter(allowed)

    /*
      ⚠️ «Karta faollashtirish» — SHARTLI band, bezak emas.

      Amal endi Kassa ekranining ichida (egasi talabi 2026-08-25), ya'ni
      Kassani ko'radigan sherikda alohida menyu KERAK EMAS. Lekin
      `voucher.activate` kassa bayrog'idan MUSTAQIL: kassasiz reseller
      (`cash_desk = f`) Kassani umuman ko'rmaydi. Bandsiz u serverda BOR
      huquqdan jimgina mahrum bo'lardi — 2026-08-21 nuqsonining takrori.

      Shart AYNAN «Kassa ko'rinmadi» bo'yicha, `subscriber.directory`
      kodini qayta yozib emas: kalit bitta joyda (`NAV_ITEMS`) turadi va
      u yerdagi shart o'zgarsa bu yer O'ZIDAN ergashadi.
    */
    const kassaVisible = primary.some((item) => item.key === 'kassa')
    const voucherFallback =
      !kassaVisible && allowed(VOUCHER_FALLBACK_ITEM) ? [VOUCHER_FALLBACK_ITEM] : []

    return {
      primary,
      secondary: [...voucherFallback, ...secondary],
      account: ACCOUNT_NAV_ITEMS.filter(allowed),
    }
  }, [can])
}
